import type { PostOrderAddressRepository } from '../../domain/interfaces/PostOrderAddressRepository';
import type { AddressSubmission } from '../../domain/models/postOrderAddress.types';

export class PostOrderAddressService {
  constructor(private repository: PostOrderAddressRepository) {}

  async fetchPendingAddress(params: { orderCode?: string | null; orderToken?: string | null }) {
    if (!params.orderCode && !params.orderToken) {
      throw new Error("Order code or Order token is required");
    }
    return this.repository.getPendingAddress(params);
  }

  async verifyPincode(pincode: string) {
    if (pincode.length < 6) throw new Error("Invalid pincode length");
    return this.repository.getPincodeDetails(pincode);
  }

  async submitAddress(submission: AddressSubmission) {
    return this.repository.submitAddress(submission);
  }
}